import React from 'react'

const Header = () => {
  return (
    <header className="w3-container w3-xlarge">
    <p className="w3-left">Jeans</p>
    <p className="w3-right">
      <i className="fa fa-shopping-cart w3-margin-right" />
      <i className="fa fa-search" />
    </p>
  </header>
  )
}

export default Header